import { css } from '@emotion/react';
import { doubleSpacing, halfSpacing, standardSpacing, tripleSpacing } from 'styles/global_defaults/scaffolding';

export const commonStyles = css`
  display: flex;
  justify-content: center;
  margin: ${standardSpacing}px ${doubleSpacing * 2}px ${doubleSpacing}px;
`;

export const containerStyles = css`
  ${commonStyles};

  .container {
    max-width: 900px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .results {
    display: flex;
    flex-direction: column;
    gap: ${standardSpacing}px;
  }

  .button-bar {
    display: flex;
    justify-content: center;
    gap: ${halfSpacing}px;
    margin-top: ${tripleSpacing}px;
  }
`;
